import TagManager from 'react-gtm-module'

export const onKDTNotification = () => {
  // GA4
  TagManager.dataLayer({
    dataLayer: {
      event: 'kdt_notification',
      ...(sessionStorage.getItem('utmAndGclid') &&
        JSON.parse(sessionStorage.getItem('utmAndGclid') as string)),
    },
  })
}
